import { useImageUrl } from '@/hooks/useFile'
import { useTranslation } from 'react-i18next'
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar'

type UserAvatarProps = {
  name?: string | null
  username?: string | null
  avatarId?: string | null
  className?: string
  fallbackClassName?: string
}

export function UserAvatar({ name, username, avatarId, className, fallbackClassName }: UserAvatarProps) {
  const { t } = useTranslation()
  const { data: avatarUrl } = useImageUrl(avatarId || undefined)
  const fallback = (name || username || 'U').slice(0, 2).toUpperCase()

  return (
    <Avatar className={className}>
      {avatarUrl ? (
        <AvatarImage src={avatarUrl} alt={name || username || t('users.user')} className="object-cover" />
      ) : null}
      <AvatarFallback className={fallbackClassName}>{fallback}</AvatarFallback>
    </Avatar>
  )
}
